import React from 'react';
import ModelType from '../ModelType';
import TextComponent from './TextComponent';
import TextAreaComponent from './TextAreaComponent';
import NumberComponent from './NumberComponent';
import OptionsComponent from './OptionsComponent';
import OptionsComponentV2 from './OptionsComponentV2';
import TimeRangeComponent from './TimeRangeComponent';
import CheckboxComponent from './CheckboxComponent';
import SwitchComponent from './SwitchComponent';
import SignalsComponent from './SignalsComponent';
import SubDialogComponent from './SubDialogComponent';
import ClipboardCopyComponent from './ClipboardCopyComponent';
import NumberInputComponent from './NumberInputComponent';
import ColorPickerComponent from './ColorPickerComponent';
import CodeEditorComponent from './CodeEditorComponent';
import JsonModalEditorComponent from './JsonModalEditorComponent';
import TreeSelectionComponent from './TreeSelectionComponent';
import RadioGroupComponent from './RadioGroupComponent';
import ToggleGroupComponent from './ToggleGroupComponent';
import NodeSelectionComponent from './NodeSelectionComponent';
import DisplayTextComponent from './DisplayTextComponent';
import PlotlinesModalComponent from './PlotlinesModalComponent';
import PlotlinesComponent from './PlotlinesComponent';
import OrgIdComponent from './OrgIdComponent';
import CustomComponent from './CustomComponent';

export const Components = {
  [ModelType.TEXT]: TextComponent,
  [ModelType.TEXTAREA]: TextAreaComponent,
  [ModelType.CLIPBOARD_COPY]: ClipboardCopyComponent,
  [ModelType.NUMBER]: NumberComponent,
  [ModelType.NUMBER_INPUT]: NumberInputComponent,
  [ModelType.OPTIONS]: OptionsComponent,
  [ModelType.OPTIONSV2]: OptionsComponentV2,
  [ModelType.TIME_RANGE]: TimeRangeComponent,
  [ModelType.CHECKBOX]: CheckboxComponent,
  [ModelType.SWITCH]: SwitchComponent,
  [ModelType.SIGNALS]: SignalsComponent,
  [ModelType.PLOTLINES]: PlotlinesComponent,
  [ModelType.PLOTLINES_MODAL]: PlotlinesModalComponent,
  [ModelType.PROPERTIES]: (props) => <SignalsComponent {...props} isProperty />,
  [ModelType.SUB_DIALOG]: SubDialogComponent,
  [ModelType.COLOR_PICKER]: ColorPickerComponent,
  [ModelType.CODE_EDITOR]: CodeEditorComponent,
  [ModelType.JSON_EDIT_DIALOG]: JsonModalEditorComponent,
  [ModelType.TREE_SELECTION]: TreeSelectionComponent,
  [ModelType.NODE_SELECTION]: NodeSelectionComponent,
  [ModelType.NODE_SELECTION_NODES]: (props) => <NodeSelectionComponent {...props} allowAssets={false} allowTypeChange={false}/>,
  [ModelType.NODE_SELECTION_ASSETS]: (props) => <NodeSelectionComponent {...props} allowNodes={false} allowTypeChange={false}/>,
  [ModelType.RADIO_GROUP]: RadioGroupComponent,
  [ModelType.TOGGLE_GROUP]: ToggleGroupComponent,
  [ModelType.DISPLAY_TEXT]: DisplayTextComponent,
  [ModelType.ORG_ID]: OrgIdComponent,
  [ModelType.CUSTOM]: CustomComponent
};
